<template>
    <div id="pipeline-form">
        <div class="row">
            <div class="input title-input">
                <div class="label">Name</div>
                <a-input class="classic-new-input" v-model:value="form.title" placeholder="Task #" />
            </div>
            <div class="input priority-input">
                <div class="label">Status</div>
                <a-select class="classic-new-select" v-model:value="form.type" :options="options" />
            </div>
        </div>
        <div class="pipeline-rules">
            <div class="title">Rules</div>
            <div class="rules-list">
                <div class="rule-item">
                    <div>
                        <div class="rule-item-title">
                            <div class="material-icons">comment</div>
                            Comments Write
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
    name: "PipelineStageForm",
    props: {
        details: {
            type: Object,
            default: () => ({
                taskId: null,
            }),
        },
    },
    data: () => ({
        form: {
            title: null,
            type: "todo",
        },
        options: [
            {
                value: "todo",
                label: this.$t("message.todo"),
            },
            {
                value: "in-progress",
                label: this.$t("message.inProgress"),
            },
            {
                value: "approval",
                label: this.$t("message.approval"),
            },
            {
                value: "completed",
                label: this.$t("message.completed"),
            },
        ],
    }),
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
        }),
    },
    methods: {
        ...mapActions({
            getTaskDetail: "tasks/getTaskDetail",
        }),
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
    },
};
</script>
<style lang="scss">
#pipeline-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .row {
        flex-wrap: nowrap;
        margin-right: 0px;
        margin-left: 0px;
        gap: 10px;
    }
    .row-bracket {
        width: 100%;
        border-bottom: 1px solid #ec4a1d2e;
        margin: 15px 0px;
    }

    .classic-new-input {
        padding: 20px;
        background: #f1f1f1;
        border: none;
        color: #3c3c3c;
        font-weight: bold;
        font-size: 14px;
        &:focus {
            border: #ec4a1d65 !important;
            box-shadow: 0 0 0 2px #ffaa0037;
        }
        &::placeholder {
            opacity: 1;
            font-weight: bold;
        }
    }
    .classic-new-select {
        width: 100%;
        font-weight: bold;
        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }

    .input {
        font-weight: bold;
        .label {
            font-size: 16px;
            margin-bottom: 4px;
        }
        &.title-input {
            width: calc(70% - 10px);
        }
        &.priority-input {
            width: 30%;
        }
    }

    .pipeline-rules {
        margin-top: 20px;
        .title {
            font-size: 20px;
            font-weight: bold;
        }
        .rules-list {
            margin-top: 10px;
            .rule-item {
                padding: 20px;
                border-radius: 4px;
                border: 1px solid #c7c7c7;
                background-color: #f0f0f0;
                user-select: none;
                &-title {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 20px;
                }
            }
            .rule-title {
                font-size: 16px;
            }
        }
    }
}
</style>
